import { Col, Container, Row } from "reactstrap"
import BackButton from "../../../../../components/common/BackButton/BackButton"
import styles from './VoucherDetails.module.scss'
import Customers from "./Customers/Customers"
import Applicability from "./Applicability/Applicability"
import Redemption from "./Redemption/Redemption"

const VoucherDetails = () => {

  const basicDetails = [
    { label: 'Voucher Name:', value: 'Text' },
    { label: 'Voucher Code:', value: 'Text' },
    { label: 'Voucher type:', value: 'Text' },
    { label: 'Validity Period:', value: 'Text' },
    { label: 'Distribution method:', value: 'Text' },
    { label: 'Monetary Value:', value: 'Text' },
    { label: 'Minimum Purchase Value:', value: 'Text' },
    { label: 'Apply to:', value: 'Text' },
    { label: 'Target Customer:', value: 'Text' },
  ]

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", paddingBlock: "1rem" }}>
      <Container fluid>
        <BackButton />
        <div className="bg-white mb-3">
          <div className="text-center py-3">
            <h5>Voucher Detail</h5>
          </div>

          <section>
            <div className={styles['heading']}>Basic Details</div>
            <Container className="px-5 d-flex flex-column gap-2 py-2">
              {basicDetails.map(item => (
                <Row>
                  <Col xs='3' className="fw-medium">{item.label}</Col>
                  <Col xs='2'>{item.value}</Col>
                </Row>
              ))}
            </Container>
          </section>

          <Customers />

          <Applicability />

          <Redemption />

        </div>

        <div className="d-flex justify-content-center">
          <div className="px-3 py-2 broder border-black rounded cursor-pointer">
            Back
          </div>
        </div>
      </Container>
    </div>
  )
}

export default VoucherDetails